import React from 'react';
import { getDaysLeft, getHoursLeft, getMinutesLeft, getSecondsLeft } from 'swag-common/utils/date-lib';
import classes from '../limited-edition-countdown/limited-edition-countdown.scss';
const getAdditionalZero = time => time > 9 ? `${time}` : `0${time}`;
const formatTime = time => {
  const days = getDaysLeft(time);
  const hours = getHoursLeft(time);
  const minutes = getMinutesLeft(time);
  const seconds = getSecondsLeft(time);
  const [hour1, hour2, hour3, hour4] = getAdditionalZero(hours).split('');
  const [minute1, minute2] = getAdditionalZero(minutes).split('');
  const [second1, second2] = getAdditionalZero(seconds).split('');
  return {
    days,
    hours,
    hour1,
    hour2,
    hour3,
    hour4,
    minute1,
    minute2,
    second1,
    second2
  };
};
export const Countdown = ({
  leftTime
}) => {
  const {
    days,
    hours,
    hour1,
    hour2,
    hour3,
    hour4,
    minute1,
    minute2,
    second1,
    second2
  } = formatTime(leftTime);
  const isMoreThan48Hours = hours >= 48;
  return /*#__PURE__*/React.createElement("span", {
    className: classes.timerContainer
  }, isMoreThan48Hours ? `${days + 1} Days` : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, hour1), /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, hour2), Boolean(hour3) && /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, hour3), Boolean(hour4) && /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, hour4), ":", /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, minute1), /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, minute2), ":", /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, second1), /*#__PURE__*/React.createElement("div", {
    className: classes.number
  }, second2), ' '));
};